'use client'
import { useEffect, useMemo, useState } from 'react'
import styles from './index.module.scss'
import { useGetUserInfoQuery } from 'core/query/hk-web/query'
import { useAuthenticate } from 'core/components/Authenticate'
import { appBridge, isInApp } from 'core/utils/appBridge'

type TResponsiveProviderProps = {
  children: React.ReactNode
  title?: string
}

export function ResponsiveProvider({ children, title }: TResponsiveProviderProps) {
  const { dispatchLogin } = useAuthenticate()
  const [token, setToken] = useState('')

  useEffect(() => {
    if (isInApp() && title) {
      appBridge.setNavTitle(title)
    }
    if (isInApp()) {
      appBridge.getAppToken().then((res) => {
        if (res?.token) {
          setToken(res.token)
          localStorage.setItem('token', res.token)
        }
      })
    }
  }, [])

  const { data: userInfoData } = useGetUserInfoQuery({
    enabled: !!token,
  })

  useEffect(() => {
    if (userInfoData?.data.data && token) {
      // 登录
      dispatchLogin({
        data: {
          token,
          userinfo: userInfoData?.data.data,
        },
        disableRedirect: true,
      })
    }
  }, [userInfoData, token])

  // layout的变更大概率不需要触发子组件的重新计算，此处避免子组件计算先
  const memoChildren = useMemo(() => children, [children])
  return <div className={styles.responsivePage}>{memoChildren}</div>
}

export default ResponsiveProvider
